import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataListModel, ApplicationRouteURL, WeGoConfig, IKeyValueInterface } from './../../shared/config';
import { SignupListService } from "../models/signup-list.service";
import { SignupModel } from "../../signup/models/signup.model";
import { SignupOverviewList } from "../models/signup-list.model";
import { FlatPickrModel } from "../../plugins/flatpickr/flatpickr.model";


@Component({
  selector: 'wego-signup-list',
  template: require('../views/signup-list.component.html'),
  providers: [SignupListService],
  styles: [`.truncate-event-data{
        max-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }`
  ]
})
export class SignupListComponent implements OnInit {
  flatPickrConfigTo: FlatPickrModel;
  flatPickrConfigFrom: FlatPickrModel;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  signupOverviewList: SignupOverviewList = new SignupOverviewList();
  DataListModel: DataListModel;
  signupList: SignupModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  urlsignupformconfigUpdatePage: string;
  isParentCheck: boolean;
  deleteSignupFormConfigHashId: string;
  errorMessage: string;
  isMultipleDelete: boolean;
  deleteMessage: string;
  urlSignupFormConfigList: string;
  errorModel: IKeyValueInterface[];

  @ViewChild('confirmSignupModal') public confirmSignupModal: any;
  private popupMsg: string;
  private module: string;


  constructor(private signupListService: SignupListService,
    private translateService: TranslateService,
    private authService: AuthService,
    private router: Router) { }


  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  ngOnInit() {
    this.module = this.translateService.instant('LblSignupForm');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["instanceName","organizationName", "userName", "email", "signupFormDescription", "statusFormatted"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlsignupformconfigUpdatePage = this.authService.GetURL(ApplicationRouteURL.URL_SIGNUPFORM_UPDATE);
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.GetSignupList();
  }

  public GetSignupList() {
    this.isLoading = true;

    this.signupListService.GetSignupList(this.signupOverviewList, this.DataListModel)
      .subscribe(
      res => {
        this.signupList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.isLoading = false;
        this.errorModel = [];
        if (typeof res.error == "string") {
          this.DataListModel.infoMessage = res.error;
        } else if (res.error) {
          this.errorModel = res.error;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetSignupList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetSignupList();
  }

  public OnDateSearch() {
    this.GetSignupList();
  }

  public OnSearch(event: any) {
    if (event.isReset) {
      this.signupOverviewList.startDateTime = '';
      this.signupOverviewList.endDateTime = '';
    }
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetSignupList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetSignupList();
  };

  public ShowAcceptrejectmodel(signupoverviewModel: SignupOverviewList) {
    this.confirmSignupModal.model = signupoverviewModel;
    this.confirmSignupModal.show();
  }

  public GetStatusText(status: string) {
    if (status == 'PENDING_APPROVAL') {
      return "Pending Approval";
    } else if (status == 'APPROVED') {
      return "Approved";
    }
    else if (status == 'REJECTED') {
      return "Rejected";
    }
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.signupListService.ExportSignupList(this.signupOverviewList, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "SignupForms" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }


  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/signupform/components/signup-list.component.ts